import badgeMilfo from '@/assets/all-badges/badge_1_the_milfo_with_a_pearl.png';
import badgeWinner from '@/assets/all-badges/badge_2_auction_winner.png';
import badgeBidder from '@/assets/all-badges/badge_3_auction_bidder.png';

const normaliseNameKey = (value) => (typeof value === 'string' ? value.trim().toLowerCase() : null);

export const PROFILE_BADGES = [
  {
    id: 'badge_1_the_milfo_with_a_pearl',
    name: 'EL MILFO DE LA PERLA',
    description: 'Awarded when you log in during the El Milfo event window.',
    image: badgeMilfo,
    rewardTitle: 'EL MILFO DE LA PERLA',
    aliases: ['MILFO DE LA PERLA', 'THE MILFO WITH A PEARL']
  },
  {
    id: 'badge_2_auction_winner',
    name: 'AUCTION MASTER',
    description: 'Granted when you win a Suarte live auction.',
    image: badgeWinner,
    rewardTitle: 'AUCTION MASTER',
    aliases: ['Auction Winner']
  },
  {
    id: 'badge_3_auction_bidder',
    name: 'AUCTION BIDDER',
    description: 'Shows you placed your first bid in a live auction.',
    image: badgeBidder,
    rewardTitle: 'AUCTION BIDDER',
    aliases: ['Auction Bidder']
  }
];

export const PROFILE_BADGES_BY_ID = PROFILE_BADGES.reduce((acc, badge) => {
  acc[badge.id] = badge;
  return acc;
}, {});

export const PROFILE_BADGES_BY_NAME = PROFILE_BADGES.reduce((acc, badge) => {
  const keys = [badge.name, ...(badge.aliases ?? [])];
  keys.forEach((key) => {
    const normalised = normaliseNameKey(key);
    if (normalised) {
      acc[normalised] = badge;
    }
  });
  return acc;
}, {});

export { normaliseNameKey };
